import { Component } from '@angular/core';
import { JavaService } from './java.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent {
    title = 'kiosk-ui';

    constructor(
        private _java: JavaService,
    ) {

    }
}
